export default __webpack_public_path__ + "static/media/dummy_thumb_3.5a0260bc.png";